/**
 * dialogs/ — Unified file/folder picker dialogs built on FS Sidecar.
 */

export type { ConfirmDialogDetailItem, ConfirmDialogProps } from "./ConfirmDialog";
export { ConfirmDialog } from "./ConfirmDialog";
export type {
  ShowConfirmDialogOptions,
  ShowFilePickerOptions,
  ShowFolderPickerOptions,
  ShowSaveDialogOptions,
} from "./DialogHost";
export {
  DialogHost,
  showConfirmDialog,
  showFilePickerDialog,
  showFolderPickerDialog,
  showSaveDialog,
} from "./DialogHost";
export { DialogButton, DialogOverlay } from "./DialogOverlay";
export { FileBrowser } from "./FileBrowser";
export type { FilePickerDialogProps } from "./FilePickerDialog";
export { FilePickerDialog } from "./FilePickerDialog";
export type { FolderPickerDialogProps } from "./FolderPickerDialog";
export { FolderPickerDialog } from "./FolderPickerDialog";
export type { SaveDialogProps } from "./SaveDialog";
export { SaveDialog } from "./SaveDialog";
export type { ShowHistoryUndoToastOptions } from "./HistorySnapshotDialog";
export {
  HistorySnapshotDialogHost,
  HistoryUndoToastHost,
  showHistorySnapshotDialog,
  showHistoryUndoToast,
} from "./HistorySnapshotDialog";
export type { ToastOptions } from "./Toast";
export { ToastHost, showToast } from "./Toast";
